module.exports = __webpack_public_path__ + "static/media/greyRadioInactive.4f5cc678.svg";